import type { ComponentType } from 'react';
import type { RouteDefinition, RouteSnapshot } from 'src/lib/router/core';
import type { ReactContainer } from 'src/ReactContainer';

export type ReactRouteComponent = ComponentType;
export type ReactRouteDefinition = RouteDefinition<ReactContainer, ReactRouteComponent>;
export type ReactRouteSnapshot = RouteSnapshot<ReactContainer, ReactRouteComponent>;

export const defineReactRoute = (definition: ReactRouteDefinition): ReactRouteDefinition => definition;
